import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=4455d30b&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/renan/Fontes/OngFacil/Edital-Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4455d30b')) {
      api.createRecord('4455d30b', component.options)
    } else {
      api.reload('4455d30b', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=4455d30b&", function () {
      api.rerender('4455d30b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/charts/BarChart.vue"
export default component.exports